import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { finalize } from "rxjs/operators";
import { EstudioMedicoPacienteService } from "app/services/estudio-medico-paciente.service";

@Component({
  selector: "app-compartir-imagenes-dialog",
  templateUrl: "./compartir-imagenes-dialog.component.html",
  styleUrls: [
    "../../compartir-receta-dialog/compartir-receta-dialog.component.scss",
    "./compartir-imagenes-dialog.component.scss",
  ],
})
export class CompartirImagenesDialogComponent {
  destination: string = "";
  enviando: boolean = false;
  error: string = "";
  enviado: boolean = false;
  venceEnHoras: number = 0;

  constructor(
    public dialogRef: MatDialogRef<CompartirImagenesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiEMP: EstudioMedicoPacienteService
  ) {
    this.destination = data.email?.endsWith(".invalid") ? "" : data.email || "";
  }

  enviar(): void {
    if (this.enviando || !this.destination) {
      return;
    }

    this.enviando = true;
    this.error = "";

    this.apiEMP
      .compartirImagenes(this.data.idEstudio, this.destination)
      .pipe(finalize(() => (this.enviando = false)))
      .subscribe({
        next: (r: any) => {
          this.enviado = true;
          this.venceEnHoras = r.vence_en_horas;
        },
        error: (err: any) => {
          this.error = err.error?.error || "No se pudo enviar el link";
        },
      });
  }
}
